import React from 'react';

const ChooseUsCard = ({ imageSrc, title, description }) => {
  return (
    <div className="bg-white rounded-lg shadow-lg p-8 text-center smallScreens:w-full h-[25.6rem] w-[40.7rem] border border-[#1C243326] flex flex-col justify-center">
      <div className="flex justify-center mb-6">
        <img src={imageSrc} alt="img" className="w-24 h-24" />
      </div>
      <h3 className="text-[2rem] font-semibold mb-4 text-gray-800">{title}</h3>
      <p className="text-gray-600 mb-6 text-[1.6rem]">{description}</p>
    </div>
  );
};
export default ChooseUsCard


